import React from 'react';
import { Link } from 'react-router-dom';
import { FaCog, FaMicrochip, FaCloud, FaBroadcastTower, FaNetworkWired, FaTools, FaBox } from 'react-icons/fa';
import './TwoColumnHomePage.css';

function TwoColumnHomePage() {
  const services = [
    {
      icon: <FaCog />,
      title: 'PLC & HMI Programming',
      description: 'Expert PLC & HMI programming in multiple languages (Structured Text, Ladder, Function Block Diagram, Sequential Function Chart) for industrial automation and process control. Multi Vendor support.',
      details: ['Siemens S7 PLCs', 'Allen-Bradley PLCs', 'Mitsubishi PLCs', 'Drives (Siemens/Allen-Bradley/Parker/Stober)', 'LabVIEW', 'Wonderware']
    },
    {
      icon: <FaMicrochip />,
      title: 'Microchip Development',
      description: 'Advanced microcontroller development and embedded systems design for specialized industrial applications.',
      details: ['ARM Cortex', 'Espressif', 'PCB Design & Assembly', 'Real-time Systems', 'Custom Firmware', 'Power Optimization']
    },
    {
      icon: <FaCloud />,
      title: 'Cloud Computing',
      description: 'Cloud infrastructure solutions for data analytics, remote monitoring, and scalable industrial applications.',
      details: ['AWS Integration', 'Real-time Analytics', 'Secure Data Handling', 'Scalable Architecture']
    },
    {
      icon: <FaBroadcastTower />,
      title: 'IoT Devices',
      description: 'IoT device development and integration for smart factory automation and predictive maintenance.',
      details: ['Sensor Networks', 'MQTT Protocols', 'Edge Computing', 'Device Management']
    },
    {
      icon: <FaNetworkWired />,
      title: 'Networks',
      description: 'Advanced networking solutions for industrial communication and device connectivity across diverse protocols and standards.',
      details: ['WiFi & Bluetooth LE', 'Zigbee', 'RS485/RS232', 'Modbus ASCII/RTU/TCP-IP', 'MTConnect', 'CANBus', 'Ethernet/IP', 'PROFIBUS', 'PROFINET', 'OPC UA','CC-Link', 'Protocol Gateways', 'Network Security', 'Industrial Firewalls', 'VPN Solutions']
    },
    {
      icon: <FaBox />,
      title: 'Industrial Panels & Hardware',
      description: 'Complete electrical panel design, build, and installation services. From custom control enclosure design and schematic creation to on-site installation and refurbishment of existing systems.',
      details: ['Control Panel Design', 'Electrical Schematics', 'Custom Enclosure Build', 'Panel Assembly & Wiring', 'On-Site Installation', 'System Refurbishment', 'Safety Compliance Testing']
    },
    {
      icon: <FaTools />,
      title: 'Support & Breakdown Services',
      description: 'Rapid breakdown support and maintenance for industrial machines. 24/7 on-call availability, with multiskilled capabilities for comprehensive repairs.',
      details: ['24/7 On-Call Support', 'Emergency Breakdown Response', 'Multiskilled Repairs', 'Preventive Maintenance', 'Machine Diagnostics', 'Field Service']
    }
  ];

  return (
    <main>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h2>Industrial Automation Solutions</h2>
          <p>Transforming Industry with Cutting-Edge Automation Technology</p>
          <div className="hero-buttons">
            <Link to="/contact" className="btn btn-primary">Get Started</Link>
            <a href="#services" className="btn btn-secondary">Learn More</a>
          </div>
        </div>
      </section>

      {/* Services Section - Two Column Layout */}
      <section id="services" className="services-two-column">
        <div className="container">
          <h2>Our Services</h2>
          <p className="section-subtitle">Comprehensive industrial automation solutions tailored to your needs</p>
          
          <div className="services-column-container">
            {services.map((service, index) => (
              <div key={index} className={`service-row ${index % 2 === 0 ? 'left' : 'right'}`}>
                <div className="service-image-placeholder">
                  <div className="service-icon-large">{service.icon}</div>
                </div>
                <div className="service-content">
                  <h3>{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  <ul className="service-details">
                    {service.details.map((detail, i) => (
                      <li key={i}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <h2>About NAK Engineering LTD</h2>
          <div className="about-profile-grid">
            <div className="about-executive-statement">
              <span className="about-profile-label">Engineering partner / critical infrastructure</span>
              <p>NAK ENGINEERING LTD is an elite engineering partner providing specialized industrial automation, custom embedded R&amp;D, and secure cloud pipelines for critical machinery infrastructure.</p>
            </div>
            <div className="about-capability-panel">
              <span className="about-profile-label">Procurement capability matrix</span>
              <ul className="about-capability-list">
                <li>18+ Years of Authoritative Field Experience</li>
                <li>Full-Lifecycle Mechatronics &amp; System Integration</li>
                <li>Multi-Vendor PLC Control Logic (Siemens, Allen-Bradley, Mitsubishi)</li>
                <li>Bare-Metal Firmware Engineering &amp; Metrology Front-Ends</li>
                <li>Serverless Industrial Telemetry Pipelines (AWS S3 &amp; QuickSight)</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <h2>Ready to Transform Your Operations?</h2>
          <p>Contact NAK ENGINEERING LTD to discuss how we can help automate your industrial processes</p>
          <Link to="/contact" className="btn btn-primary">Contact Us Today</Link>
        </div>
      </section>
    </main>
  );
}


export default TwoColumnHomePage;
